import React from "react";

import { Collapsible } from "~/components/collapsible";
import { CollapsibleContent } from "~/components/collapsible/content";
import { CollapsibleTrigger } from "~/components/collapsible/trigger";
import { IconChevronDown } from "~/components/icon";
import { cx } from "~/tools/class-variance";

// TODO(anton): Discuss migrating Markdown to src/components/markdown/ — reuses react-markdown stack
import { Markdown } from "../../components/react/markdown/Markdown";

interface ThinkingToggleProps {
	thinking: string;
	open: boolean;
	isLive?: boolean;
	onOpenChange: (open: boolean) => void;
}

export const ThinkingToggle: React.FC<ThinkingToggleProps> = ({ thinking, open, isLive = false, onOpenChange }) => (
	<Collapsible className="px-1" onOpenChange={onOpenChange} open={open}>
		<CollapsibleTrigger className="flex items-center gap-1 rounded-md text-xs transition-colors hover:text-grey-900">
			<IconChevronDown className={cx("size-3 text-grey-500 transition-transform", !open && "-rotate-90")} />
			<span className={cx("font-medium", open ? "text-grey-800" : "text-grey-600")}>
				{open ? "Hide reasoning" : "View reasoning"}
			</span>
			{!open && isLive && (
				<span className="ml-1 inline-flex items-center gap-1 text-primary-600 text-xs">
					<span aria-hidden className="size-1.5 animate-pulse rounded-full bg-primary-600" />
					Liz is thinking...
				</span>
			)}
		</CollapsibleTrigger>
		<CollapsibleContent>
			<div className="mt-2 max-h-60 overflow-y-auto rounded-lg border border-grey-300 bg-grey-100 p-3 shadow-inner">
				<p className="mb-2 font-medium text-grey-600 text-xs">Reasoning</p>
				<div className="text-grey-800 text-xs">
					<Markdown copyCodeToClipboard openLinksInNewTab sanitize text={thinking} />
				</div>
			</div>
		</CollapsibleContent>
	</Collapsible>
);
